(function() {

    angular
    .module('meanApp')
    .service('nutritionService', nutritionService);

    nutritionService.$inject = [];
    function nutritionService () {

        //BELOW constants about good and bad things
        var SALTCATEGORIES = [0, 0.46, 0.92, 1.62, 2.3],
        SALTNAMING = ['Pas de sel', 'Peu de sel', 'Faible impact', 'Un peu trop salé','Trop salé'],
        SUGARCATEGORIES = [0, 9, 18, 21, 45],
        SUGARNAMING= ['Pas de sucre', 'Peu de sucre', 'Faible impact', 'Un peu trop sucré', 'Trop sucré'],
        FATCATEGORIES = [0, 2, 4, 7, 10],
        FATNAMING=['Pas de graisses saturées', 'Peu de graisses saturées', 'Faible impact', 'Un peu trop de graisses saturées', 'Trop de graisses saturées'],
        CALORYCATEGORIES = [0, 160, 360, 560, 800],
        CALORYNAMING = ['Pas de calories', 'Peu de calories', 'Faible impact', 'Un peu trop calorique', 'Trop calorique'],
        FIBERCATEGORIES = [0, 3.5, 7],//always good
        FIBERNAMING=['Quelques protéines', 'Excellente quantité'],
        PROTEINCATEGORIES = [0, 8, 16],//always good
        PROTEINNAMING = ['Quelques protéines', 'Excellente quantité'];    

        this._getLevel = function (value, arrayLevel) {
            var level = 1;
            if(value < arrayLevel[1]) {
                level= 1;
            }
            else if (value < arrayLevel[2]) {
                level= 2;
            }
            else if (value < arrayLevel[3]) {
                level= 3;
            }
            else {
                level = 4;
            }
            return level;
        };

        this._roundQuantity = function(value) {
            return ((Math.round(value * 10) / 10)+'').replace('.', ',');
        };

        //return good things and bad things when passing nutrients of ingredients or recipes
        this.getGoodAndBadThings = function(nutrientsQuantity) {
            var goodThings = [],
            badThings = [];

            nutrientsQuantity.forEach(function(nutrientQuantity) {
                var nutrient = nutrientQuantity.nutrient,
                quantity = nutrientQuantity.quantity,
                unit = nutrient.unit,
                level, 
                dataStructure;

                switch(nutrient._id) {
                //fibers
                    case 291: 
                        if (quantity > 0) {
                            goodThings.push({
                                name : 'Fibres',
                                description: quantity < FIBERCATEGORIES[1] ? FIBERNAMING[0] : FIBERNAMING[1],
                                level : quantity < FIBERCATEGORIES[1] ? 2 : 1,
                                iconName : 'fob-wheat',
                                quantity : this._roundQuantity(quantity),
                                unit: unit
                            });
                        }
                    break;
                    //proteins
                    case 203: 
                        if (quantity > 0) {
                            goodThings.push({
                                name : 'Protéines',
                                description: quantity < PROTEINCATEGORIES[1] ? PROTEINNAMING[0] : PROTEINNAMING[1],
                                level : quantity < PROTEINCATEGORIES[1] ? 2 : 1,
                                iconName : 'fob-muscles',
                                quantity : this._roundQuantity(quantity),
                                unit: unit
                            });
                        }
                    break;
                    //kilocalories energy
                    case 208: 
                        level = this._getLevel(quantity, CALORYCATEGORIES);
                        dataStructure = {
                            name: 'Calories',
                            description : CALORYNAMING[level],
                            iconName: 'fob-fire',
                            level : level,
                            quantity : this._roundQuantity(quantity),
                            unit : unit
                        };
                        if (level <= 2) {
                            goodThings.push(dataStructure);
                        }
                        else {
                            badThings.push(dataStructure);
                        }
                    break;
                    //fatty acids saturated
                    case 606:
                        level = this._getLevel(quantity, FATCATEGORIES);
                        dataStructure = {
                            name: 'Graisses saturées',
                            description : FATNAMING[level],
                            iconName: 'fob-oil',
                            level: level,
                            quantity : this._roundQuantity(quantity),
                            unit: unit
                        };
                        if(level <=2) {
                            goodThings.push(dataStructure);
                        }
                        else {
                            badThings.push(dataStructure);
                        }
                    break;
                    //sodium converted into salt
                    case 307:
                        quantity = (quantity/1000)*2.54; //convert sodium into grams of salt
                        level = this._getLevel(quantity, SALTCATEGORIES);
                        dataStructure = {
                            name: 'Sel',
                            description : SALTNAMING[level],
                            iconName: 'fob-salt',
                            level: level,
                            quantity : this._roundQuantity(quantity),
                            unit: 'g'
                        };
                        if(level <=2) {
                            goodThings.push(dataStructure);
                        }
                        else {
                            badThings.push(dataStructure);
                        }
                    break;
                    //case sugars
                    case 269:
                        level = this._getLevel(quantity, SUGARCATEGORIES);
                        dataStructure = {
                            name: 'Sucre',
                            description : SUGARNAMING[level],
                            iconName: 'fob-toffee',
                            level: level,
                            quantity : this._roundQuantity(quantity),
                            unit: unit
                        };
                        if(level <=2) {
                            goodThings.push(dataStructure);
                        }
                        else {
                            badThings.push(dataStructure);
                        }
                    break;
                }
            }.bind(this));

            //sort good and badthings
            goodThings.sort(function(a, b) {
                return a.level - b.level;
            });

            badThings.sort(function(a, b) {
                return b.level - a.level;
            });

            return {
                goodThings : goodThings,
                badThings: badThings
            };
        };

        return this;
    }

})();